const getGlobalStatus = state => state?.platform?.global?.status;
const getIsMaintenanceMode = state => state?.platform?.global?.maintenance?.isMaintenanceMode;
const getMaintenanceConfig = state => state?.platform?.global?.maintenance?.config;

export { getGlobalStatus, getMaintenanceConfig, getIsMaintenanceMode };
